import React from 'react'
import { TextField } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import colors from '../CustomizedUIs/Colors'
const useStyles = (disabled) => makeStyles(theme => ({
    input: {
        backgroundColor: 'white !important',
        borderRadius: '2px',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: '#4f5064 !important',
        paddingLeft: '20px',
        fontFamily: 'text-security-disc',
        "-webkit-text-security": "disc",
        '&[type=number]': {
            '-moz-appearance': 'textfield',
        },
        '&::-webkit-outer-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0,
        },
        '&::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0,
        },
    },
    inputShowPassword: {
        fontFamily: 'UniviaPro',
        "-webkit-text-security": 'none'
    },

    disabled: {
        backgroundColor: '#ffffff',
        color: 'inherit'
    },
    underline: {
        '&::before': {
            borderBottom: disabled ? '1px solid #b4b5bd !important' : '1px solid black !important'
        },
        '&:hover:before': {
            borderBottom: '1px solid black'
        }
    },
    underlineNotValue: {
        '&::before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        },
        '&:hover:before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        }
    },
    underlineError: {
        '&::after': {
            borderBottom: '2px solid' + '#eb5a4d'
        }
    },
    focuses: {
        backgroundColor: 'white !important'
    },
    textError: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: 'normal',
    },
    textLabel: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: '#88898c !important',
        paddingLeft: '16px'
    },
    textLabelError: {
        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
    }
}));

const CustomTextFieldPinCode = ({ endDom, ...props }) => {
    const classes = useStyles(props.disabled)();
    return (
        <TextField
            {...props}
            FormHelperTextProps={{
                className: classes.textError
            }}
            InputLabelProps={{
                classes: {
                    root: classes.textLabel,
                    error: classes.textLabelError,
                }
            }}
            InputProps={{
                endAdornment: endDom,
                classes: {
                    underline: props.error ? classes.underlineError : (props.value !== '' ? classes.underline : classes.underlineNotValue),
                    focused: classes.focuses,
                    disabled: classes.disabled
                }
            }}
            inputProps={{
                className: `${classes.input} ${props.showPassword ? classes.inputShowPassword : ''}`,
                maxLength: 6,
            }}
            variant="filled"
        />
    )
}
export default CustomTextFieldPinCode